import { INDEED, JOVEO } from '@/types/channels';

import { DefaultForm } from './default-form';
import { IndeedForm } from './indeed-form';
import { JoveoForm } from './joveo-form';

interface ChannelSwitcherProps {
  channelSlug: string;
}

export function ChannelSwitcher({ channelSlug }: ChannelSwitcherProps) {
  switch (channelSlug) {
    case JOVEO:
      return <JoveoForm />;
    case INDEED:
      return <IndeedForm />;
    default:
      return <DefaultForm />;
  }
}
